<template>
    <div>
        <nsw-menu :isShowDesktopMenu="false"></nsw-menu>
        <div class="content-wrapper general">
            <h3 class="title-head">{{ lang($t("Contact Us")) }}</h3>
            <div class="content-box contact">
                <p>如閣下有任何查詢，請透過以下途徑與我們聯絡</p>

                <div class="divTable contact-info-table">
                    <div class="TBody">
                        <div class="TR">
                            <div class="TD">
                                <img src="img/office-hour.svg" />
                            </div>
                            <div class="TD">
                                <p>
                                    星期一至五 9:30-13:00，14:30-18:00
                                </p>
                            </div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/phone.svg" /></div>
                            <div class="TD"><p>+853 6802 1885</p></div>
                        </div>
                        <div class="TR">
                            <div class="TD"><img src="img/email.svg" /></div>
                            <div class="TD">
                                <a
                                    class="txt-link"
                                    href="mailto:edu853ky@gmail.com"
                                    >edu853ky@gmail.com</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { common } from "@mixins/common";
import { storeMapper } from "@mixins/storeMapper";
import api from "@js/api";
import EventBus from "@common/eventBus";
import { nsw_common } from "@mixins/nsw_common";

export default {
    name: "ContactUs",
    mixins: [common, storeMapper, nsw_common],
    /**路由相處理
     * 第一次進入本頁面時的動作。
     * @param to
     * @param from
     * @param next
     */
    beforeRouteEnter(to, from, next) {
        //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
        next(vm => {
            EventBus.$emit("showGlobalLoading");

            Promise.all(
                [api.getMainCate()]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                    .map(p => p.catch(() => undefined))
            ).then(
                axios.spread(responseMainCate => {
                    if (responseMainCate) {
                        vm.setWebSiteAndCate(responseMainCate.data, vm);
                    }
                    EventBus.$emit("hideGlobalLoading");
                })
            );
            /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */
        });
    }
};
</script>

<style>
.title-head:first-child {
    margin-top: 0;
}

.divTable {
    display: table;
    width: 100%;
}

.divTable .TBody {
    display: table-row-group;
}

.divTable .TR {
    display: table-row;
}

.divTable .TD {
    display: table-cell;
    vertical-align: top;
}

.content-box.contact {
    margin-bottom: 1.5rem;
}
.content-box.contact > p {
    line-height: 170%;
    padding-bottom: 1.5rem;
}
h4.contact-title {
    font-size: 1rem;
    padding-bottom: 1rem;
    color: #608197;
}
.content-box.contact .action-btn {
    margin-top: 1.5rem;
}

.contact-info-table .TD img {
    width: 1.25rem;
    height: 1.25rem;
}
.contact-info-table .TD {
    padding-bottom: 0.75rem;
}
.contact-info-table .TR:last-child .TD {
    padding-bottom: 0rem;
}
.contact-info-table .TD:first-child {
    width: 2.25rem;
}
.contact-info-table .TD:last-child {
    padding-top: 0.125rem;
}
.contact-info-table .TD p {
    color: #8d8d8d;
}

@media screen and (max-width: 767px) {
    h4.contact-title {
        padding: 0 0.5rem 1rem 0.5rem;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactUs.vue